(function (window, document) {
	const swiperNav = new Swiper('#swiper-app', {
		slidesPerView: 'auto',
		initialSlide: 1,
		centeredSlides: true,
		speed: 600,
		resistanceRatio: 0,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	$(document).ready(function () {
		const width = $('.sec-cont-iqDesc-pic')[0].clientWidth;
		$('.sec-cont-iqDesc-pic').css('height', width)
		$(window).resize(function () {
			const width = $('.sec-cont-iqDesc-pic')[0].clientWidth;
			$('.sec-cont-iqDesc-pic').css('height', width)
		});
	});
})(window, document);